<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        车辆数据导出
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            icon="e6-icon-add_line"
            @click="$router.push('vehicleDataExportAdd')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.timeRange">
            <el-date-picker
              v-model="slotForms.forms.timeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.status">
            <el-select v-model="slotForms.forms.status" placeholder="当前状态">
              <el-option label="导出中" :value="1"> </el-option>
              <el-option label="导出成功" :value="2"> </el-option>
              <el-option label="导出失败" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.taskNo">
            <el-input
              v-model="slotForms.forms.taskNo"
              placeholder="任务ID"
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        border
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          fixed="left"
          type="index"
          width="55"
        ></el-table-column>
        <el-table-column
          label="任务ID"
          prop="taskNo"
          min-width="140"
          header-align="center"
          align="left"
          show-overflow-tooltip
          fixed="left"
        >
        </el-table-column>
        <el-table-column
          label="车辆数"
          prop="vehicleCount"
          min-width="110"
          header-align="center"
          align="right"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="导出时间段"
          prop="timeQuantum"
          min-width="150"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="当前状态"
          min-width="100"
          header-align="center"
          align="center"
          show-overflow-tooltip
          class-name="now-status"
        >
          <template slot-scope="{ row }">
            <span :class="['state', 'state_' + row.status]">{{
              nowStatus(row.status)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="导出原因"
          prop="remark"
          min-width="150"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="下载"
          min-width="240"
          header-align="center"
          align="left"
          show-overflow-tooltip
          class-name="down"
        >
          <template slot-scope="{ row }"
            ><span
              class="down-address"
              v-if="row.status == 2"
              @click="handleDownFile(row.fileName)"
              >{{ row.fileName }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="createdTime"
          min-width="150"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="formExtend.forms.pageParamVO.pageSize"
        :currentPage.sync="formExtend.forms.pageParamVO.curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import { FetchFindByPage } from "@/api/systemSetting/vehicleDataExport";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";

export default {
  mixins: [resizeListener],
  data() {
    return {
      total: 0,
      isSearch: false,
      formExtend: {
        forms: {
          timeRange: [
            moment().format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ], // 时间
          beginTime: "", // 开始时间
          endTime: "", // 结束时间
          status: "", // 当前状态
          taskNo: "", //任务id
          pageParamVO: {
            curPage: 1,
            pageSize: 10
          }
        },
        extends: []
      },
      formsExtend: [],
      tableData: [], //表格数据
      loading: "false",
      fileUrl: "/report/ExportDataTask/download?fileName="
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    this.FetchFindByPage(this.mergeObj());
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 获取表格数据
    FetchFindByPage(response) {
      this.loading = true;
      let tableData = [];
      let total = 0;
      FetchFindByPage(response)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            tableData = response.result.data;
            total = response.result.totalRecords;
          }
          this.tableData = tableData;
          this.total = total;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 整合查询数据
    mergeObj() {
      let param = cloneDeep(this.formExtend);
      param.forms.beginTime = moment(param.forms.timeRange[0]).format(
        "YYYY-MM-DD"
      );
      param.forms.endTime = moment(param.forms.timeRange[1]).format(
        "YYYY-MM-DD"
      );
      delete param.forms.timeRange;
      return Object.assign({}, mergeFormExtend(param));
    },

    // 是否展开查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },

    // 点击查询按钮查询数据
    handlesSubmitForm() {
      if (!this.formExtend.forms.timeRange) {
        this.$message.warning("请选择开始日期与结束日期");
        return;
      }
      this.FetchFindByPage(this.mergeObj());
    },

    // 翻页
    handleCurrentChange(e) {
      this.formExtend.forms.pageParamVO.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 设置每页多少条
    handleSizeChange(e) {
      this.formExtend.forms.pageParamVO.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 下载文件
    handleDownFile(fileName) {
      let url = this.fileUrl + fileName;
      document.location.href = url;
    },

    // 当前状态
    nowStatus(code) {
      let result = "";
      switch (code) {
        case 1:
          result = "导出中";
          break;
        case 2:
          result = "导出成功";
          break;
        case 3:
          result = "导出失败";
          break;
        default:
          result = "";
      }
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
  // 当前状态
  .now-status {
    .state {
      color: #fff;
      display: block;
      width: 80px;
      margin: 0 auto;
      height: 24px;
      line-height: 24px;
      border-radius: 40px;

      &_1 {
        background-color: #ffc107;
      }

      &_2 {
        background-color: #4caf50;
      }

      &_3 {
        background-color: #f44336;
      }
    }
  }

  // 下载地址
  .down {
    &-address {
      cursor: pointer;
      color: #2196f3;
    }
  }
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.nodata {
  color: #999;
  font-size: 18px;
  text-align: center;
  margin-top: 270px;
}
</style>
